import { useContext } from "react";
import { AuthContext } from "../context/auth-context";
export var useAuth = function () {
  return useContext(AuthContext) || {
    isAvailable: false
  };
};